const replaceElementWithBulk = function replaceElementWithBulk(array, oldElement, newElementsArray) {
  const oldElementIndex = array.indexOf(oldElement);

  if (oldElementIndex < 0) {
    return array;
  }

  return [...array.slice(0, oldElementIndex), ...newElementsArray, ...array.slice(oldElementIndex + 1)];
};

const removeBulkInArray = function removeBulkInArray(array, toRemove) {
  return array.filter(el => toRemove.indexOf(el) < 0);
};

export const pushNextSteps = (...nextSteps) => flow => {
  return [...nextSteps, ...flow.filter(step => nextSteps.indexOf(step) < 0)];
};
export const removeSteps = (...stepsToRemove) => flow => {
  return removeBulkInArray(flow, stepsToRemove);
};
export const pushNextAndRemove = (nextSteps, stepsToRemove) => flow => {
  return removeBulkInArray(pushNextSteps(...nextSteps)(flow), stepsToRemove);
};
export const replaceStep = (oldStep, ...newSteps) => flow => {
  return replaceElementWithBulk(flow, oldStep, newSteps);
};
export const addStepsAfterStep = (step, ...newSteps) => flow => {
  return flow.reduce((newFlow, value) => {
    if (value === step) {
      newFlow.push(step, ...newSteps);
      return newFlow;
    }

    newFlow.push(value);
    return newFlow;
  }, []);
};
export const FlowManager = {
  pushNextSteps,
  removeSteps,
  replaceStep,
  pushNextAndRemove,
  addStepsAfterStep
};